import { createAction, props } from '@ngrx/store';
import {
  AuthData,
  Profile,
  CreateCustomerData,
  ResetCustomerData,
  CreateAccessTokenData,
  CustomerAccessToken,
  ShopifyError,
  ActivateCustomerData,
  Customer,
} from '../../models';
import { Order } from '../../models/order.model';

export const LoadCustomer = createAction('[Customer] Load Customer');
export const LoadCustomerSuccess = createAction('[Customer] Load Customer Success', props<{ customer: Customer }>());
export const LoadCustomerFail = createAction('[Customer] Load Customer Fail', props<{ errors: any }>());

export const CreateCustomer = createAction('[Customer] Create Customer', props<{ data: CreateCustomerData }>());
export const CreateCustomerSuccess = createAction('[Customer] Create Customer Success', props<{ customer: CreateCustomerData }>());
export const CreateCustomerFail = createAction('[Customer] Create Customer Fail', props<{ errors: ShopifyError[] }>());

export const SendInvitation = createAction('[Customer] Send Invitation', props<{ email: string }>());
export const SendInvitationSuccess = createAction('[Customer] Send Invitation Success', props<{ success: boolean }>());
export const SendInvitationFail = createAction('[Customer] Send Invitation Fail', props<{ errors: any }>());

export const CreateCustomerAccessToken = createAction('[Customer] Create Customer Access Token', props<{ data: CreateAccessTokenData }>());
export const CreateCustomerAccessTokenSuccess = createAction(
  '[Customer] Create Customer Access Token Success',
  props<{ token: CustomerAccessToken; email?: string }>()
);
export const CreateCustomerAccessTokenFail = createAction(
  '[Customer] Create Customer Access Token Fail',
  props<{ errors: ShopifyError[] }>()
);

export const InitCustomerAccessToken = createAction('[Customer] Initialize Customer Access Token');
export const InitCustomerAccessTokenSuccess = createAction(
  '[Customer] Initialize Customer Access Token Success',
  props<{ token?: CustomerAccessToken }>()
);
export const InitCustomerAccessTokenFail = createAction(
  '[Customer] Initialize Customer Access Token Fail',
  props<{ errors: ShopifyError[] }>()
);

export const DeleteCustomerAccessToken = createAction('[Customer] Delete Customer Access Token');
export const DeleteCustomerAccessTokenSuccess = createAction('[Customer] Delete Customer Access Token Success');
export const DeleteCustomerAccessTokenFail = createAction(
  '[Customer] Delete Customer Access Token Fail',
  props<{ errors: ShopifyError[] }>()
);

export const RecoverCustomer = createAction('[Customer] Recover Customer', props<{ email: string }>());
export const RecoverCustomerSuccess = createAction('[Customer] Recover Customer success', props<{ email: string }>());
export const RecoverCustomerFail = createAction('[Customer] Recover Customer fail', props<{ errors: ShopifyError[] }>());

export const ResetCustomer = createAction('[Customer] Reset Customer', props<{ resetCustomerData: ResetCustomerData }>());
export const ResetCustomerSucces = createAction('[Customer] Reset Customer Success');
export const ResetCustomerFail = createAction('[Customer] Reset Customer Fail', props<{ errors: ShopifyError[] }>());

export const ActivateCustomer = createAction('[Customer] Confirm Account', props<{ activateCustomerData: ActivateCustomerData }>());
export const ActivateCustomerSuccess = createAction('[Customer] Confirm Account Success', props<{ result: any }>());
export const ActivateCustomerFail = createAction('[Customer] Confirm Account Fail', props<{ errors: ShopifyError[] }>());

export const UpdateCustomer = createAction('[Customer] Update Account', props<{ customer: Customer }>());
export const UpdateCustomerSuccess = createAction('[Customer] Update Account Success', props<{ customer: Customer }>());
export const UpdateCustomerFail = createAction('[Customer] Update Account Fail', props<{ errors: ShopifyError[] }>());

export const SetDefaultAddress = createAction('[Addresses] Set Default Address', props<{ id: string }>());
export const SetDefaultAddressSuccess = createAction('[Addresses] Set Default Address Success', props<{ address: any }>());
export const SetDefaultAddressFail = createAction('[Addresses] Set Default Address Fail', props<{ errors: ShopifyError[] }>());
